module.exports = __webpack_public_path__ + "static/img/service1.4d53b542.png";